<div class="input-wrapper">
  <ion-item mode="ios">
    <ion-input
      labelPlacement="floating"
      class="bold-text"
      readonly="{{ readOnly }}"
      disabled="{{ disabled }}"
      min="0"
      type="{{ textInputType }}"
      [ngClass]="{ capitalize: question.underwriting_answers[0].object_field === 'surname_on_id' }"
      value="{{ question.underwriting_answers[0].object_answer }}"
      (input)="answerValue($event)"
    >
    <div slot="label">
      <ion-text class="standard-input-label">{{showHeading ? question.underwriting_answers[0].place_holder : ''}}</ion-text>
    </div>
  </ion-input>
  </ion-item>
  <p class="error-message" *ngIf="error">{{ error }}</p>
</div>
